import React from "react";

function ManageSubscriptionDrawer() {
  return <div>ManageSubscriptionDrawer</div>;
}

export default ManageSubscriptionDrawer;
